// extracted by mini-css-extract-plugin
export default {"block":"ui_block__9Zz6M","iconWrapper":"ui_iconWrapper__2tlVI","text":"ui_text__pMJLF"};